import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup } from "vue"

import {computed, onMounted, ref} from 'vue';
import WidgetTab from "~/chat/vue/widget/WidgetTab.vue";
import ChatHistory from "~/chat/vue/widget/tabs/chat/ChatHistory.vue";
import ChatHeader from "~/chat/vue/widget/tabs/chat/ChatHeader.vue";
import ChatFooter from "~/chat/vue/widget/tabs/chat/ChatFooter.vue";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import IChatFooter from "~/chat/vue/widget/tabs/chat/IChatFooter";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import OfflineHtmlContent from "~/chat/vue/widget/tabs/chat/OfflineHtmlContent.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ContentTab from "~/chat/vue/widget/tabs/ContentTab.vue";
import {IWidgetTabParams} from "~/chat/ts/data/ITab";
import {OFFLINE_FORM_TAB_ID} from "~/chat/ts/Constants";
import RateRequestInHeader from "~/chat/vue/widget/tabs/chat/RateRequestInHeader.vue";
import {RATE_DISPLAY_TYPE_AFTER_HEADER} from "~/chat/ts/data/ISiteParams";


import ChatUploadOverlay from "~/chat/vue/widget/upload/ChatUploadOverlay.vue";

const __default__ = {
    name: "ChatTab",
    components: {
        ChatUploadOverlay
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let isUploadEnabled = computed(() => {
    return chatMode.value.allowFileDragOverlay && ConfigStore.siteParams.value.params.siteChatOptions.upload;
});

let chatFooterRef = ref<IChatFooter>();

function onFileUpload(files: IChatUploadFile[]) {
    chatFooterRef.value.attachFiles(files);
}

function markAllMessagesAsReaded() {
    if (ChatTabStore.isScrolledToBottom.value) {
        MessageStorage.setMessageReaded();
    }
}

let chatMode = computed(() => {
    return ChatTabStore.chatTabMode.value;
});

let replaceTab = computed<IWidgetTabParams>(() => {
    if (chatMode.value.replaceChatTab) {
        return ConfigStore.replaceChatTab.value;
    } else if (ChatTabStore.isOfflineFormDisplayed.value) {
        return {
            id: OFFLINE_FORM_TAB_ID,
            type: OFFLINE_FORM_TAB_ID,
            title: "",
            visible: 1,
            weight: 0
        };
    }
    return null;
});

onMounted(() => {
    let requestRate = ConfigStore.siteParams.value.params.rate.requestRate;
    if (requestRate.enabled && requestRate.afterMessagesCount === 0) {
        ChatTabStore.showRateRequest(MessageStorage.lastMessageId ?? 0);
    }
});

let offlineTabTitle = computed(() => {
    return ConfigStore.siteParams.value.params.leadGen.tabTitle;
});

let showRateRequest = computed(() => {
    return ConfigStore.siteParams.value.params.rate.requestRate.displayType == RATE_DISPLAY_TYPE_AFTER_HEADER && typeof ChatTabStore.showRateRequestAfterMessage.value === "number";
});

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "zoom-slowly",
    tag: "span"
  }, {
    default: _withCtx(() => [
      (_unref(chatMode).showOfflineHtmlContentInsteadOfChat)
        ? (_openBlock(), _createBlock(OfflineHtmlContent, { key: "html" }))
        : (_unref(replaceTab))
          ? (_openBlock(), _createBlock(ContentTab, {
              "use-default-close-handler": "",
              tab: _unref(replaceTab),
              title: _unref(offlineTabTitle),
              key: "replace"
            }, null, 8, ["tab", "title"]))
          : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(WidgetTab, { key: "chat" }, {
        header: _withCtx(() => [
          _createVNode(ChatHeader)
        ]),
        content: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isUploadEnabled) ? ChatUploadOverlay : 'div'), {
            onNewFiles: onFileUpload,
            class: "d-flex vertical absolute-full-size"
          }, {
            default: _withCtx(() => [
              (_unref(showRateRequest))
                ? (_openBlock(), _createBlock(RateRequestInHeader, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(ChatHistory, { class: "filler" }),
              _createVNode(ChatFooter, {
                ref_key: "chatFooterRef",
                ref: chatFooterRef
              }, null, 512)
            ]),
            _: 1
          }, 32))
        ]),
        _: 1
      })), [
        [_directive_on_native, markAllMessagesAsReaded, "keyup"],
        [_directive_on_native, markAllMessagesAsReaded, "touchend"],
        [_directive_on_native, markAllMessagesAsReaded, "touchstart"],
        [_directive_on_native, markAllMessagesAsReaded, "click"],
        [_directive_on_native, markAllMessagesAsReaded, "mousemove"]
      ])
    ]),
    _: 1
  }))
}
}

})